<section class="dialogCustom" *ngIf="!isEmpty">
  <button
    mat-icon-button
    aria-label="close icon"
    class="dialogCustom__button button"
    (click)="close()"
  >
    <mat-icon class="button__icon">close</mat-icon>
  </button>
  <article class="dialogCustom__header header">
    <img class="header__img" [src]="icon" alt="icon dialog" />
    <h3 class="header__title">{{ title }}</h3>
    <p class="header__description" [innerHTML]="description"></p>
  </article>

  <article class="dialogCustom__buttons buttons">
    <button
      type="button"
      *ngFor="let button of buttons"
      [id]="button.type"
      class="buttons__button button"
      [ngClass]="{ onlyOne: buttons.length === 1 }"
      (click)="methodCallback(button.method)"
    >
      {{ button.name }}
    </button>
  </article>
</section>
